<template>
    <div class="address">
        <div v-if="recipient !== null">{{ recipient }}</div>
        <div>{{ street }} {{ street_number }}</div>
        <div>{{ post_code }} {{ city }}</div>
    </div>
</template>

<script>
    export default {
        props: {
            recipient: {type: String, default: null},
            post_code: String,
            city: String,
            street: String,
            street_number: String,
        },
    };
</script>